import { render } from "./DocumentValidationTable.vue?vue&type=template&id=0da8455d"
import script from "./DocumentValidationTable.vue?vue&type=script&lang=js"
export * from "./DocumentValidationTable.vue?vue&type=script&lang=js"
script.render = render

export default script